import stylesheet0 from "../common/common.css";

export default [stylesheet0];